<template>
  <modal-template>
    <template #header>
      <div style="width:100%;float:left;">
        <div class="modal-header-style">
          <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
            <span>new order</span>
          </div>
          <div style="float:right;">
            <label class="action-icon-style" v-on:click="$emit('close', true)">
              <font-awesome-icon icon="xmark" size="xl"/>
              <span style="display: block;">close</span>
            </label>
          </div>
        </div>
        <div style="width:100%;float:left;">
          <div style="font-size:larger;font-weight:bold;">
            <sup>[{{ account.customerId }}]</sup> {{account.customerName }}
          </div>
          <div>serviced by <sup>[{{ account.dairyId }}]</sup> {{ account.dairyName }}</div>
        </div>
      </div>
    </template>
    <template #body>
      <div style="width:100%;float:left;padding-top:2%;">
        <delivery-days :dairy-id="account.dairyId"
                       :customer-id="account.customerId"
                       :delivery-type="account.deliveryType"
                       :review="review"
                       :bad-day="badDay"
                       @apierror="setApiError"
                       @apierrortext="setApiErrorText"
                       @deliveryday="loadDeliveryDay"
                       @noorder="loadNoOrder"
                       @isvalid="loadDeliveryDaySentinel">
        </delivery-days>
      </div>
      <div>
        <purchase-order v-if="!noOrder"
                        :mandatory="account.mandatoryPO"
                        :review="review"
                        @purchaseorder="loadPurchaseOrder"
                        @isvalid="loadPurchaseOrderSentinel">
        </purchase-order>
      </div>
      <div>
        <product-list v-if="!noOrder"
                      :dairy-id="account.dairyId"
                      :dairy-name="account.dairyName"
                      :customer-id="account.customerId"
                      :price-deck="account.priceDeck"
                      :review="review"
                      :iscopy="iscopy"
                      :productstocopy="productstocopy"
                      @apierror="setApiError"
                      @apierrortext="setApiErrorText"
                      @orderproducts="loadProducts"
                      @hasunits="loadHasUnits"
                      @isvalid="loadQuantitySentinel">
        </product-list>
      </div>
      <div style="min-height:40px;">
        <div v-if="(noOrder && validDeliveryDay) || (review && validDeliveryDay && validPurchaseOrder && validQuantity)"
             style="text-align:right;">
          <button type="button" v-on:click="cancelReview" style="float:left;">cancel</button>
          <button type="button" v-on:click="checkCutOff" style="float:right;">submit</button>
        </div>
        <div v-else-if="hasUnits && validDeliveryDay" style="text-align:right;">
          <button type="button" v-on:click="reviewOrder">review</button>
        </div>
      </div>
    </template>
    <template #footer>
    </template>
  </modal-template>
  <submit-past-cut-off v-if="displayPastCutOff"
                       :account="account"
                       @close="displayPastCutOff = false">
  </submit-past-cut-off>
  <order-confirmation v-if="displayOrderConfirmation"
                      :text="confirmationText"
                      @close="closeMe">
  </order-confirmation>
</template>

<script>
import ProductList from '@/components/ordering/products/OrderList'
import DeliveryDays from '@/components/ordering/schedule/DeliveryDays'
import PurchaseOrder from '@/components/ordering/PurchaseOrder'
import SubmitPastCutOff from '@/components/ordering/SubmitPastCutOff'
import OrderConfirmation from '@/components/ordering/OrderConfirmation'
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'Compose',
  components: {
    ProductList,
    DeliveryDays,
    PurchaseOrder,
    SubmitPastCutOff,
    OrderConfirmation,
    ModalTemplate
  },
  props: ['account', 'username', 'iscopy', 'productstocopy'],
  emits: ['close', 'submittedOrder', 'apierror', 'apierrortext'],
  data: function () {
    return {
      products: [],
      deliveryDay: {},
      purchaseOrder: '',
      hasUnits: false,
      review: false,
      badDay: {},
      submit: false,
      noOrder: false,
      validDeliveryDay: false,
      validPurchaseOrder: false,
      validQuantity: false,
      displayPastCutOff: false,
      displayOrderConfirmation: false,
      confirmationText: ''
    }
  },
  methods: {
    loadProducts(products) {
      this.products = products
    },
    loadQuantitySentinel(isValid) {
      this.validQuantity = isValid
    },
    loadDeliveryDay(day) {
      this.deliveryDay = day
    },
    loadDeliveryDaySentinel(isValid) {
      this.validDeliveryDay = isValid
    },
    loadPurchaseOrder(purchaseOrder) {
      this.purchaseOrder = purchaseOrder
    },
    loadPurchaseOrderSentinel(isValid) {
      this.validPurchaseOrder = isValid
    },
    loadHasUnits(hasUnits) {
      this.hasUnits = hasUnits
    },
    loadNoOrder(noOrder) {
      this.noOrder = noOrder
      this.review = this.noOrder
    },
    cancelReview() {
      for (const product of this.products) {
        product.visible = true
      }
      this.review = false
    },
    reviewOrder() {
      if (this.hasUnits && this.validDeliveryDay && this.validPurchaseOrder && this.validQuantity)
        this.review = true
    },
    async checkCutOff() {
      let isPastCutOff = true
      const response = await this.axios
          .get('schedule/pastCutOff', {
            params: {
              dairyId: this.account.dairyId,
              cutOff: this.deliveryDay.cutOff,
            },
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })

      if (response.status === 200) {
        isPastCutOff = response.data
        if (isPastCutOff) {
          this.displayPastCutOff = true
          this.cancelReview()
        } else {
          this.submitOrder()
        }
      }

      return isPastCutOff
    },
    submitOrder: function () {
      this.displayOrderConfirmation = false

      if ((this.noOrder && this.validDeliveryDay) ||
          (this.review && this.validDeliveryDay && this.validPurchaseOrder && this.validQuantity)) {
        if (this.noOrder) this.products = []

        let orderTotal = _.sumBy(this.products, function (o) {
          return (o.pricePer * o.packagings);
        })

        let productsOnOrder = this.products

        productsOnOrder = _.filter(productsOnOrder, (product => product.units > 0 || product.packagings > 0))

        productsOnOrder = productsOnOrder.filter(function (props) {
          delete props.visible
          delete props.rank
          return true
        });

        productsOnOrder = _.orderBy(productsOnOrder, ['sortSequence'], ['asc'])

        this.axios
            .post('orders/save', {
              cachedOrder: {
                dairyId: this.account.dairyId,
                accountId: this.account.customerId,
                deliveryType: this.account.deliveryType,
                orderId: '', //doesn't exist yet
                deliveryDate: this.deliveryDay.deliveryDate,
                purchaseOrder: this.purchaseOrder,
                placedBy: this.username,
                placedOn: this.getTimestamp(),
                priceDeck: this.account.priceDeck,
                orderDatePricing: this.account.orderDatePricing,
                cancelled: false,
                noOrder: this.noOrder,
                cutOff: this.deliveryDay.cutOff,
                totalPrice: orderTotal.toFixed(2),
                products: productsOnOrder
              },
              schedule: {
                deliveryDate: this.deliveryDay.deliveryDate,
                cutOff: this.deliveryDay.cutOff,
                used: this.deliveryDay.used,
                creditTicket: this.deliveryDay.creditTicket,
                loadDay: this.deliveryDay.loadDay,
                deliveryRoute: this.deliveryDay.deliveryRoute,
                plantRoute: this.deliveryDay.plantRoute,
                driver: this.deliveryDay.driver,
                loadSequence: this.deliveryDay.loadSequence,
                deliverySequence: this.deliveryDay.deliverySequence
              }
            })
            .then(response => {
              if (response.data.responseCode === 200) {
                this.$emit('close', true)
              } else if (response.data.responseCode === 303) {
                this.displayOrderConfirmation = true
                this.confirmationText = response.data.text
                this.badDay = true
              } else if (response.data.responseCode === 404) {
                this.displayOrderConfirmation = true
                this.confirmationText = response.data.text
              }
            })
            .catch(error => {
              this.setApiError(true)
              this.setApiErrorText(error.response.statusText)
            })
      }
    },
    closeMe: function () {
      this.displayOrderConfirmation = false
      this.cancelReview()
    },
    setApiError: function (apiError) {
      this.$emit('apierror', apiError)
    },
    setApiErrorText: function (apiErrorText) {
      this.$emit('apierrortext', apiErrorText)
    },
    getTimestamp: function () {
      const now = new Date()

      return now.getFullYear() + "-" +
          ('00' + (now.getMonth() + 1)).slice(-2) + '-' +
          ('00' + now.getDate()).slice(-2) + 'T' +
          ('00' + now.getHours()).slice(-2) + ':' +
          ('00' + now.getMinutes()).slice(-2) + ':' +
          ('00' + now.getSeconds()).slice(-2)
    },
  },
  mounted() {
    this.hasUnits = false
    this.review = false
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
